import { MyContextProvider } from "../../ra-lb-tools/components/myContext";
import { ClientsList, ClientsView } from "../clients";

const forcedCustomFields = ["webhooks"];

export const OrgClientsList = (props) => {
  return (
    <ClientsList
      title="My Clients"
      forcedCustomFields={forcedCustomFields}
      {...props}
    />
  );
};

export const OrgClientsShow = () => {
  return (
    <MyContextProvider value={{ forcedCustomFields }}>
      <ClientsView />
    </MyContextProvider>
  );
};
